import { z } from 'zod';
/**
 * Branded id for the singleton email layout row (`email_layout.is_default`).
 * Multiple rows are supported for future tenancy / A/B; MVP ships one.
 */
export const EmailLayoutId = z.guid().brand();
export const EmailLayoutDTO = z.object({
    id: EmailLayoutId,
    name: z.string().min(1).max(200),
    html: z.string().min(1),
    isDefault: z.boolean(),
    version: z.number().int().positive(),
    updatedByAdminId: z.guid().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const UpdateEmailLayoutRequest = z.object({
    html: z
        .string()
        .min(1, 'Required')
        .max(200_000, 'Too long')
        .refine((html) => html.includes('{{body}}'), {
        message: 'Layout HTML must include the {{body}} token — otherwise outgoing replies lose their content.',
    }),
});
/**
 * @deprecated The layout-render engine (token substitution, plain-text
 * composition, outbound HTML assembly) moved to `@wit-support/email-render`
 * — it isn't a wire contract, just server/UI-shared rendering logic. Import
 * from `@wit-support/email-render` directly in new code. Re-exported here,
 * unchanged, only for back-compat with any caller still importing it from
 * this package.
 */
export { LAYOUT_TOKENS, renderEmailLayout, composeOutbound, toInnerHtml, stripLegacyShell, htmlToPlainText, } from '@wit-support/email-render';
//# sourceMappingURL=email-layout.js.map